import { useEffect, useState } from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import Authentication from '../oauth/Authentication'
import storage from '../presentation/util/storage'

interface PrivateRouteProps extends RouteProps {
  roles?: string[]
  modules?: string[]
}

const PrivateRoute = ({ roles, modules, ...rest }: PrivateRouteProps): JSX.Element => {
  const [isAuthenticated, setAuthenticated] = useState<boolean>(false)
  const userRole = storage.getRole()
  const userProfile = storage.getUserInformation()  
  const isAuthorized =
    (!roles || roles.includes(userRole)) &&
    (modules?.some(m => userProfile?.modules?.includes(m)) ?? true);

  useEffect(() => {
    if (!isAuthenticated) {
      Authentication.isLogged().then(isAuthenticated => {
        if (!isAuthenticated) {
          if(!Authentication.authorize(false)) {
            window.location.replace(`/logout`)
          }
        } else {
          setAuthenticated(true)
        }
      })
    }
  }, [roles, userRole, isAuthenticated])

  if (!isAuthorized) {
    return <Redirect to="/tableau-de-bord" />
  }

  return (
    <Route {...rest} />
  )
}

export default PrivateRoute
